module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1037.1b8efe79.png";